@if(loader){
<app-loader></app-loader>
}
<p-card [header]="editRole ?  'Update Roles' : 'Create Roles'">
    <form [formGroup]="createRoleForm" style="height: 82vh;">

        <div class="col">

            <div class="field col-12 flex justify-content-between align-items-center">
                <div class="flex justify-content-start">
                    @if(editRole){
                    <p-button label="Update" icon="pi pi-arrow-circle-up" severity="info" size="small"
                        (click)="updateRole()"></p-button>
                    }@else{
                    <p-button label="Save" icon="pi pi-save" size="small"
                        (click)="createRole(createRoleForm.value)"></p-button>
                    }
                    <p-button label="Cancel" icon="pi pi-times" size="small" severity="danger" (click)="Cancel()"
                        class="ml-2"></p-button>
                </div>

                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

        </div>

        <div class="card flex justify-content-end">
            <p-checkbox formControlName="isActive" [binary]="true" inputId="binary" value="isActive"
                label="isActive"></p-checkbox>
        </div>
        <div class="grid">
            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Role</label>
                    <input pInputText placeholder="e.g Production" formControlName="RoleName"
                        (keydown)="onKeydown($event)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.RoleName.errors }"
                        class="w-full p-inputtext-sm" (keydown)="onKeydown($event)" />
                    <small *ngIf="submitted && formControls.RoleName.errors" id="role-error"
                        class="text-red-500">Required
                        field.</small>
                </div>
            </div>

            <div class="col">
                <div class="field text-left">
                    <label for="website" class="label-required display">Role Description</label>
                    <input pInputText placeholder="e.g Production department working" class="w-full p-inputtext-sm"
                        formControlName="RoleDescription"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.RoleDescription.errors }"
                        (keydown)="onKeydown($event)" (keydown)="onKeydown($event)" />
                    <small *ngIf="submitted && formControls.RoleDescription.errors" id="description-error"
                        class="text-red-500">Required
                        field.</small>
                </div>
            </div>
        </div>

    </form>
</p-card>

<p-toast></p-toast>